import { ICoinflipGame } from "@api/types/Coinflip";
import { ApolloError, useMutation } from "@apollo/client";
import { JOIN_COINFLIP_GAME } from "@graphql/Mutations";
import { AppState } from "@redux/stores/store";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";

export default function useJoinCoinflipGame(
  coinflip: ICoinflipGame,
  {
    onCompleted,
    onError,
  }: {
    // eslint-disable-next-line no-unused-vars
    onCompleted: (game: ICoinflipGame) => void;
    // eslint-disable-next-line no-unused-vars
    onError: (error: ApolloError) => void;
  }
): () => Promise<void> {
  const user = useSelector((state: AppState) => state.userData);
  const [isJoining, setIsJoining] = useState<boolean>(false);
  const [joinCoinflipGame] = useMutation(JOIN_COINFLIP_GAME, {
    onCompleted: ({ joinCoinflipGame }) => {
      onCompleted(joinCoinflipGame);
      setIsJoining(false);
    },
    onError: (e) => {
      onError(e);
      setIsJoining(false);
    },
  });

  const joinGame = useCallback(async () => {
    if (!isJoining) {
      setIsJoining(true);
      await joinCoinflipGame({
        variables: {
          gameUid: coinflip.uid,
          userId: user.id,
        },
      });
    }
  }, [coinflip, isJoining]);

  return joinGame;
}
